import { EMPTY_STR } from "@/constants/string";
import { toNumber } from "@/utils/number";

/** % 入力で許可する小数桁数（DB は NUMERIC(5,4) のため小数表記で4桁 = % 表記で2桁） */
export const TAX_RATE_PERCENT_DECIMAL_PLACES = 2;

/** % 入力の上限（小数表記の上限 9.9999 に対応） */
export const TAX_RATE_PERCENT_MAX = 999.99;

/**
 * 小数表記の税率を % の数値へ変換する（0.08 → 8）。
 * `0.07 * 100 = 7.000000000000001` のような浮動小数点誤差を丸めて除去する。
 */
export const rateToPercent = (rate?: number | null): number => {
  return Number((toNumber(rate) * 100).toFixed(TAX_RATE_PERCENT_DECIMAL_PLACES));
};

/** 表示用の % 文字列に変換する（0.08 → "8%"）。値が無い場合はハイフンを返す */
export const formatRateToPercentText = (rate?: number | null): string => {
  if (rate === null || rate === undefined) return EMPTY_STR.TEXT;
  return `${rateToPercent(rate)}%`;
};

/**
 * 入力された % を API 送信用の小数表記へ変換する（10 → 0.1）。
 * % のまま送ると 1000% として登録されてしまうため、送信前に必ず通す。
 */
export const percentToRate = (percent?: number | null): number => {
  return Number((toNumber(percent) / 100).toFixed(4));
};
